import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Col } from 'react-bootstrap';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import './RoomOverview.scss';
import { createFetch } from '../../../utils';
import lang from '../../../lang';
import OtherPassanger from './OtherPassanger';
const { SF_URL, SF_PAGE_URL} = window;


export class FlightInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            flightIn: {},
            loading: true,
            flightOut: {},
            otherPassenger: {
                in: [],
                out: [],
            },
        };
        this.getFlightInfoDetail = this.getFlightInfoDetail.bind(this);
    }

    async componentWillMount() {
        this.getFlightInfoDetail(true);
        if (typeof this.props.flightInfo.in === 'object') {
            this.setState({
                flightIn: this.props.flightInfo.in,
                flightOut: this.props.flightInfo.out,
                loading: false,
            });
            return;
        }
    }

    async getFlightInfoDetail(forceRefresh = false) {
        this.setState({ loading: true });
        const { accessToken } = this.props.user;
        const { flightInfo } = this.props;
        const ids = {
            in: typeof flightInfo.in === 'object' ? flightInfo.in.Id : flightInfo.in,
            out: typeof flightInfo.out === 'object' ? flightInfo.out.Id : flightInfo.out,
        };

        ids.in = /[a-zA-Z0-9]{18}|[a-zA-Z0-9]{15}/i.test(ids.in) ? ids.in : null;
        ids.out = /[a-zA-Z0-9]{18}|[a-zA-Z0-9]{15}/i.test(ids.out) ? ids.out : null;
        try {
            const {
                0: flightIn,
                1: flightOut,
                2: otherPassengerIn,
                3: otherPassengerOut,
            } = await Promise.all([
                createFetch({
                    path: `ama/flight-detail/${ids.in}?forceRefresh=${forceRefresh.toString()}`,
                    accessToken,
                    body: null,
                    method: 'GET',
                }),
                createFetch({
                    path: `ama/flight-detail/${ids.out}?forceRefresh=${forceRefresh.toString()}`,
                    accessToken,
                    body: null,
                    method: 'GET',
                }),
                createFetch({
                    path: `ama/other-passanger?forceRefresh=${forceRefresh.toString()}&flightId=${ids.in}`,
                    method: 'get',
                    accessToken,
                }),
                createFetch({
                    path: `ama/other-passanger?forceRefresh=${forceRefresh.toString()}&flightId=${ids.out}`,
                    method: 'get',
                    accessToken,
                }),
            ]);
            this.setState({
                flightIn,
                flightOut,
                otherPassenger: {
                    in: otherPassengerIn.records || [],
                    out: otherPassengerOut.records || [],
                },
                loading: false,
            });
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                title: lang.titleError,
                text: error.message,
                type: 'warning',
            });
        }
    }

    render() {
        const { props } = this;
        const { loading, flightIn, flightOut, otherPassenger } = this.state;
        return (
            <div className="flight-info row">
                <h1>
                    Flight Info &nbsp;&nbsp;&nbsp;
                    <button
                        className="btn btn-default"
                        onClick={() => this.getFlightInfoDetail(true)}
                        style={{ backgroundColor: '#5AC4CF' }}
                    >
                        <i className="fa fa-sync" />
                    </button>
                </h1>
                {loading ? (
                    <p className=" text-center">
                        <i className="fa fa-circle-notch fa-spin fa-2x loading" />
                    </p>
                ) : null}
                <Col sm="12">
                    <Tabs
                        activeKey={props.keyStroke}
                        id="controlled-tab-example"
                    >
                        <Tab eventKey={1} title="In Flight">
                            <div className="row">
                                <Col sm="12" className="table-reponsive">
                                    {this.props.flightInfo.in ? (
                                        <FlightDetail
                                            detail={this.state.flightIn}
                                            holiday={this.state.flightIn?.Holiday_Season__c || this.state.flightOut?.Holiday_Season__c}
                                            otherPass={otherPassenger.in}
                                        />
                                    ) : (
                                        <div>
                                            <h3>No flight on this date</h3>
                                            <p>
                                                Please check your flight
                                                information on this date in
                                                salesforce.
                                            </p>
                                        </div>
                                    )}
                                </Col>
                            </div>
                            {flightIn ?
                                <OtherPassanger
                                    data={otherPassenger.in || []}
                                /> : null
                            }
                        </Tab>
                        <Tab eventKey={2} title="Out Flight">
                            <div className="row">
                                <Col sm="12" className="table-reponsive">
                                    {this.props.flightInfo.out ? (
                                        <FlightDetail
                                            detail={this.state.flightOut}
                                            holiday={this.state.flightIn?.Holiday_Season__c || this.state.flightOut?.Holiday_Season__c}
                                            otherPass={otherPassenger.out}

                                        />
                                    ) : (
                                        <div>
                                            <h3>No flight on this date</h3>
                                            <p>
                                                Please check your flight
                                                information on this date in
                                                salesforce.
                                            </p>
                                        </div>
                                    )}
                                </Col>
                            </div>
                            {
                                flightOut ?
                                    <OtherPassanger
                                        data={otherPassenger.out}
                                    />
                                    : null
                            }
                        </Tab>
                    </Tabs>
                </Col>
            </div>
        );
    }
}

FlightInfo.propTypes = {
    flightInfo: PropTypes.object,
    user: PropTypes.object.isRequired,
};

FlightInfo.defaultProps = {
    flightInfo: {},
};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});


export const FlightInfoRedux = connect(mapStateToProps, mapDispatchToProps)(FlightInfo);

const FlightDetail = props => (
    <table className="table table-stripped" id="inFlightInfo">
        <thead />
        <tbody>
            <tr>
                {console.log(props.detail)}
                <td>Flight ID </td>
                <td width={20}>:</td>
                <td>
                    <a
                        href={`${SF_PAGE_URL}${props.detail.Id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {props.detail.Name}
                    </a>
                </td>
                <td>Flight No. </td>
                <td width={20}>:</td>
                <td>{props.detail.Flight_No__c}</td>
            </tr>
            <tr>
                <td>ETA - Bali Time</td>
                <td width={20}>:</td>
                <td>
                    {props.detail.Departure_Date_Time__c
                        ? moment(props.detail.Departure_Date_Time__c)
                            .tz('Asia/Makassar')
                            .format('DD/MM/YYYY hh:mm a')
                        : ''}
                </td>
                <td>ETD - Bali Time</td>
                <td width={20}>:</td>
                <td>
                    {props.detail.Arrival_Date_Time__c
                        ? moment(props.detail.Arrival_Date_Time__c)
                            .tz('Asia/Makassar')
                            .format('DD/MM/YYYY hh:mm a')
                        : ''}
                </td>
            </tr>
            <tr>
                <td>Flight Price </td>
                <td width={20}>:</td>
                <td>${props.detail.Flight_Price__c}</td>
                <td>Availablity </td>
                <td width={20}>:</td>
                <td>{props.detail.Availability__c}</td>
            </tr>
            <tr>
                <td>Confirmed Guests</td>
                <td width={20}>:</td>
                <td>{props.detail.Confirmed_Guests__c}</td>
                <td>Empty Seat</td>
                <td width={20}>:</td>
                <td>{props.detail.Empty_Seats__c}</td>
            </tr>
            <tr>
                {/* <td>Employees</td>
                <td width={20}>:</td>
                <td>{props.detail.Employees__c}</td> */}
                <td>Other Passengers</td>
                <td width={20}>:</td>
                <td>{props.otherPass ? props.otherPass.length : 0}</td>
                <td>Max. Payload </td>
                <td width={20}>:</td>
                <td>{props.detail.Max_Payload_Kg__c} Kg</td>
            </tr>
            <tr>
                <td>Flight From </td>
                <td width={20}>:</td>
                <td>{props.detail.From_Location__c} </td>
                <td>Holiday Season </td>
                <td width={20}>:</td>
                <td>{props.holiday ? 'Yes' : 'No'} </td>
            </tr>
        </tbody>
    </table>
);

FlightDetail.propTypes = {
    detail: PropTypes.object.isRequired,
};
export const VisitInfo = (props) => {
    let visitInfoDetail = props.visitData;
    if (typeof visitInfoDetail === 'string') visitInfoDetail = {};
    visitInfoDetail.Segments = visitInfoDetail.Segments === undefined ? [] : visitInfoDetail.Segments;
    return (
        <div className="flight-info row">
            <h1>
                <a href={`${SF_PAGE_URL}${visitInfoDetail.Sales_Order_No__r.Opportunity_Name__c}`} target="_blank" rel="noopener noreferrer">
                    {visitInfoDetail.Sales_Order_No__r.Opportunity_Name__r ? visitInfoDetail.Sales_Order_No__r.Opportunity_Name__r.Name : ''}
                </a>
            </h1>
            <Col sm="12" className="table-reponsive">
                <table className="table table-stripped" id="inFlightInfo">
                    <thead />
                    <tbody>
                        <tr>
                            <td>Salesperson</td>
                            <td>:</td>
                            <td>
                                {
                                    visitInfoDetail.Sales_Order_No__r.Sales_Person__r ? visitInfoDetail.Sales_Order_No__r.Sales_Person__r.Name : ''
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>Sales Order No.</td>
                            <td width={20}>:</td>
                            <td width={220}>
                                {
                                    visitInfoDetail.Sales_Order_No__r ?
                                        <a href={`${SF_PAGE_URL}${visitInfoDetail.Sales_Order_No__c}`} target="_blank" rel="noopener noreferrer">
                                            {visitInfoDetail.Sales_Order_No__r.Name}
                                        </a>
                                        : <i>None</i>
                                }
                            </td>
                            <td>Room Allocation No. </td>
                            <td width={20}>:</td>
                            <td width={220}>{visitInfoDetail.Name }</td>
                        </tr>
                        <tr>
                            <td>Start Date</td>
                            <td width={20}>:</td>
                            <td width={220}>{moment(visitInfoDetail.Start_Date__c).format('ddd, DD-MM-YYYY') }</td>
                            <td>End Date</td>
                            <td width={20}>:</td>
                            <td width={220}>{moment(visitInfoDetail.End_Date__c).format('ddd, DD-MM-YYYY')}</td>
                        </tr>
                        <tr>
                            <td>Room Assigned</td>
                            <td width={20}>:</td>
                            <td>{visitInfoDetail.Room_Assigned__r ? visitInfoDetail.Room_Assigned__r.Name : <i>None</i>}</td>
                            <td>Remarks </td>
                            <td width={20}>:</td>
                            <td>{visitInfoDetail.Remarks__c}</td>
                        </tr>
                        <tr>
                            <td>Allocation Status</td>
                            <td width={20}>:</td>
                            <td>{visitInfoDetail.Allocation_Status__c}</td>
                            <td>No. Of occupants </td>
                            <td width={20}>:</td>
                            <td>{visitInfoDetail.No_of_Occupants__c}</td>
                        </tr>
                        <tr>
                            <td>Sharing Type</td>
                            <td width={20}>:</td>
                            <td>{visitInfoDetail.Sharing_Type__c}</td>
                            <td>Room Type</td>
                            <td width={20}>:</td>
                            <td>{visitInfoDetail.RoomType__c}</td>
                        </tr>
                    </tbody>
                </table>
                <table className="table table-bordered table-stripped">
                    <thead>
                        <tr>
                            <th>Segment No.</th>
                            <th>Guest FullName</th>
                            <th>Gender</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Duration</th>
                            <th>Segment Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visitInfoDetail.Segments.map((obj, key) => (<tr>
                            <td>{obj.Name}</td>
                            <td>{obj.Guest_Full_Name__c}</td>
                            <td>{obj.GenderF__c}</td>
                            <td>{moment(obj.Start_Date__c).format('DD/MM/YYYY')}</td>
                            <td>{moment(obj.End_Date__c).format('DD/MM/YYYY')}</td>
                            <td>{obj.Duration_night__c}</td>
                            <td>{obj.Segment_Status__c}</td>
                        </tr>))}
                    </tbody>
                </table>
            </Col>
        </div>
    );
};


VisitInfo.propTypes = {
    visitData: PropTypes.string.isRequired,
};
